<template>
    <div>数据权限</div>
</template>

<script setup>

</script>

<style scoped>

</style>
